import { Group } from '@centered/types'
import GroupLeaderboard from './GroupLeaderboard'
import GroupsLeaderboard from './GroupsLeaderboard'

interface CommunityLeaderboardProps {
  group?: Group
}

export default function CommunityLeaderboard({
  group,
}: CommunityLeaderboardProps): JSX.Element {
  return (
    <div
      style={{
        background: `linear-gradient(52.39deg, rgba(39, 39, 39, 0.6) -2.39%, rgba(30, 30, 30, 0.6) 97.61%)`,
      }}
      className="py-20"
    >
      <div className="w-full max-w-2xl mx-auto px-4">
        <header className="mb-8">
          <h1 className="text-center text-3xl font-semibold mb-4">
            Feel the Power of Community
          </h1>

          <p className="text-white text-opacity-40 text-center">
            Centered is filled with groups to help you stay accountable and
            succeed.
          </p>
        </header>

        {group ? (
          <GroupLeaderboard groupId={group.id} groupName={group.name} />
        ) : (
          <GroupsLeaderboard />
        )}
      </div>
    </div>
  )
}
